var map = {
	"./black_cerebra_logo.svg": 96,
	"./color-logo.png": 97,
	"./custom-white-logo.svg": 98,
	"./favicon.ico": 99,
	"./logo.png": 100,
	"./logo.svg": 63,
	"./tip-color-logo.svg": 44,
	"./tip-color-round.png": 101,
	"./tip-white-logo.svg": 102,
	"./tip-white-round.png": 103,
	"./vuexy-logo.png": 104,
	"./white-logo.png": 105,
	"./white_cerebra_logo.svg": 106
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87;